import { Button } from '@material-ui/core';
import React, { useRef, useState } from 'react'
import Http from '../../../Http';
import Snackbar from '../../../components/alert/Snackbar';

export default function ClientesSubir() {
  const inputRef = useRef(null);
  const [Loading, setLoading] = useState(false);

  const onSubirClick = () => {
    // Snackbar('hola');
    // return;
    inputRef.current.click();
  }

  const onSubirChange = async (e) => {
    const file = e.target.files[0];
    setLoading(true);
    try {
      let form = new FormData();
      form.append('file', file);
      let res = await Http.post(`clientes/excel`, form);
      console.log(res.data);
      if (!res.error) {
        Snackbar(`Clientes subidos`);
      }
      else {
        Snackbar(`Error: ${res.errMsg}`);
      }
    } catch (error) {
      console.log(error);
      Snackbar(`Error al subir el archivo`);
    }
    inputRef.current.value = null;
    setLoading(false);
  }

  return (
    <div>
      <Button variant='outlined' onClick={onSubirClick} disabled={Loading}>Subir clientes</Button>
      <input type='file' ref={inputRef} onChange={onSubirChange} hidden />
    </div>
  )
}
